import {
  FieldLabel,
  SegmentedChoice,
} from "../../../../../components/propertyDescription/descriptionUi";
import {
  FURNITURE_STATUS_OPTIONS,
  parseFurnitureStatus,
  type FurnitureStatus,
} from "../../../../../utils/propertyFurniture";

type FurnitureStatusFieldProps = {
  value: unknown;
  onChange: (value: FurnitureStatus) => void;
};

export default function FurnitureStatusField({
  value,
  onChange,
}: FurnitureStatusFieldProps) {
  return (
    <div className="mb-3">
      <FieldLabel>Mobília</FieldLabel>
      <SegmentedChoice
        value={parseFurnitureStatus(value)}
        onChange={onChange}
        options={FURNITURE_STATUS_OPTIONS}
      />
    </div>
  );
}
